export var qrLoginMixin = {
  watch: { 
  },
  
  data(){
    return{

    }
  },
  computed: {
  },
  methods: {
    hasQRData(){
      return !!this.getQrData();
    },
    getQrData(){
      return (this.$route && this.$route.query)?this.$route.query.d:'';
    },
    getQrEventId(){
      return (this.$route && this.$route.query)?this.$route.query.e:null;
    },
    getDecodedQrData(){
      let dataParam=(this.$route && this.$route.query)?this.$route.query.d:null;
      let encoded ="";
      try{
        encoded= atob(dataParam)
      }catch(ex){
        console.warn(ex);
      }
      return encoded;
    },
    // bound to an account: autoLogin or teamLogin followed by the account hash (EspotoQRType.EventAccountQR)
    isAutoLogin(){
      let encoded = this.getDecodedQrData();
      return encoded.includes('_autoLogin_') || encoded.includes('_teamLogin_')
    },
    isGuestLogin(){
      let encoded = this.getDecodedQrData();
      return encoded.endsWith('autoLogin')
    },
    // open team: guest registration joins the team
    isTeamLogin(){
      let encoded = this.getDecodedQrData();
      return encoded.endsWith('_teamLogin')
    },
  }
}
